import { useEffect } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Hero } from "@/components/site/Hero";
import { Manifesto } from "@/components/site/Manifesto";
import { MacdConnectInvite } from "@/components/site/MacdConnectInvite";
import { Atmosphere } from "@/components/site/Atmosphere";
import { MACD } from "@/components/site/MACD";
import { DoCorteAoLucro } from "@/components/site/DoCorteAoLucro";
import { Formacoes } from "@/components/site/Formacoes";
import { Gilson } from "@/components/site/Gilson";
import { Insights } from "@/components/site/Insights";
import { FinalCTA } from "@/components/site/FinalCTA";
import { useReveal } from "@/hooks/useReveal";

export default function Home() {
  const rootRef = useReveal();

  useEffect(() => {
    // Scroll to hash if present (for /#section after route change)
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 80);
      }
    }
  }, []);

  return (
    <div ref={rootRef} data-testid="home-page" className="bg-white">
      <Navbar />
      <main>
        <Hero />
        <Manifesto />
        <MacdConnectInvite />
        <Atmosphere />
        <MACD />
        <DoCorteAoLucro />
        <Formacoes />
        <Gilson />
        <Insights />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
